<template>
  <div>
    <div class="wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLayout',
  components: {},
}
</script>

<style lang="scss">
.form-wrapper {
  width: 90%;
  height: auto;
  margin: rem(70px) auto rem(30px);

  @include media_custom(350px) {
    width: 350px;
    margin: rem(100px) auto rem(30px);
  }
}
</style>
